import { required } from "vuelidate/lib/validators";

export default class ProdutoData {
  produtos = [];
  subTotal = 0;
  constructor(produtos = [], subtotal = 0) {
    this.produtos = produtos;
    this.subtotal = subtotal;
  }
}

export const ProdutoDataRequired = {
  produtos: {
    required,
  },
};
